import { z } from 'zod';
export const SyntheticProbeTypeSchema = z.enum([
    'http_health',
    'db_ping',
    'queue_latency',
    'backup_staleness',
    'tls_cert',
]);
export const ProbeResultStatusSchema = z.enum(['success', 'warning', 'failure']);
export const SyntheticProbeSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    probeType: SyntheticProbeTypeSchema,
    targetInstallationId: z.string().nullable().optional(),
    targetUrl: z.string().nullable().optional(),
    intervalSeconds: z.number().int().positive().default(60),
    timeoutMs: z.number().int().positive().default(5000),
    status: z.enum(['active', 'paused']).default('active'),
    lastRunAt: z.iso.datetime().nullable().optional(),
    lastResult: ProbeResultStatusSchema.nullable().optional(),
    lastLatencyMs: z.number().nonnegative().nullable().optional(),
    lastErrorMessage: z.string().nullable().optional(),
    consecutiveFailures: z.number().int().nonnegative().default(0),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
export const SloStatusSchema = z.enum(['meeting_slo', 'at_risk', 'breached']);
export const FleetSloMetricSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    description: z.string(),
    targetPercentage: z.number().min(0).max(100),
    currentPercentage: z.number().min(0).max(100),
    windowHours: z.number().int().positive().default(720),
    status: SloStatusSchema,
    errorBudgetRemainingPercent: z.number().min(0).max(100),
    updatedAt: z.iso.datetime(),
});
export const AnomalySeveritySchema = z.enum(['low', 'medium', 'high', 'critical']);
export const AnomalyStatusSchema = z.enum(['open', 'investigating', 'resolved', 'ignored']);
export const AnomalyEventSchema = z.object({
    id: z.uuid(),
    installationId: z.string(),
    installationName: z.string().optional(),
    anomalyType: z.enum([
        'error_spike',
        'stale_heartbeat',
        'backup_missed',
        'unauthorized_signature',
        'replay_attempt',
        'component_degradation',
    ]),
    severity: AnomalySeveritySchema,
    status: AnomalyStatusSchema.default('open'),
    title: z.string(),
    description: z.string(),
    details: z.record(z.string(), z.unknown()).optional(),
    detectedAt: z.iso.datetime(),
    resolvedAt: z.iso.datetime().nullable().optional(),
    resolvedByUserId: z.string().nullable().optional(),
});
//# sourceMappingURL=reliability.js.map